// Renommez ce fichier 'config.js' une fois votre objet de configuration 
// Firebase inclut ci-dessous :
const firebaseConfig = {
    apiKey: "AIzaSyBlHQrPM1ntGG2oiuGdRYqdsMrNXH9eoQo",
    authDomain: "iwra-4pa.firebaseapp.com",
    projectId: "iwra-4pa",
    storageBucket: "iwra-4pa.appspot.com",
    messagingSenderId: "250341683171",
    appId: "1:250341683171:web:a5711114fc0087906fbad6",
    measurementId: "G-ERZ8N3C54W"
};

export default firebaseConfig;